<template>
  <div
    v-if="['web', 'custom_defined', 'ios', 'android_os', 'android_tv'].includes(model.device_type)"
    class="promo-design-group"
  >
    <div class="rf-rc-close-buttons-optq">
      <v-checkbox
        v-if="model.path_type === 'horizontal'"
        v-model="actions.rf_settings_disable_click"
        trueValue="true"
        falseValue="false"
        label="Passive"
        class="promotion-closeBtn-checkbox"
      />
    </div>
    <div class="rf-rc-close-buttons-opt">
      <v-checkbox
        v-if="['web', 'custom_defined'].includes(model.device_type) && clickOutsideSupported"
        v-model="actions.rf_settings_click_outside_close_enabled"
        trueValue="true"
        falseValue="false"
        label="Click outside to close"
        class="promotion-closeBtn-checkbox"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "RfRetentionBehavior",
  props: ["actions", "model", "clickOutsideSupported"],
};
</script>
